export default __webpack_public_path__ + "static/media/cross_arrow_white.8bc5ef8d.svg";